module.exports = __webpack_public_path__ + "static/magician-cutout-6b73d49c04746990d5200dfb1c0969e0.png";